<template>
  <div class="modal is-active">
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="pa-modal">
          <div class="pa-modal__title">Recommend a booster (admin)</div>
          <div class="pa-modal__body">
            The client sees a dismissible card: “Recommended: {{ boosterName }}. Your SEO Manager recommends
            a {{ packLabel }} for "{{ siteName }}".” and gets one email in your voice. Add a note to say why.
            <div class="pa-recommend-modal__fields">
              <label class="pa-recommend-modal__field">
                <span>Booster</span>
                <select v-model="boosterKey" class="pa-sel">
                  <option v-for="b in catalogue" :key="b.key" :value="b.key">{{ b.name }}</option>
                </select>
              </label>
              <label class="pa-recommend-modal__field">
                <span>Pack</span>
                <select v-model="packKey" class="pa-sel">
                  <option v-for="p in packs" :key="p.key" :value="p.key">{{ p.label }} (${{ money(p.price) }})</option>
                </select>
              </label>
              <textarea
                v-model="note"
                class="pa-in pa-recommend-modal__note"
                rows="3"
                maxlength="1000"
                placeholder="Why this booster now? (optional, shown to the client)"
              ></textarea>
            </div>
          </div>
          <div class="pa-modal__actions">
            <button type="button" class="pa-btn pa-btn--out" @click="$emit('close')">Cancel</button>
            <button
              type="button"
              class="pa-btn pa-btn--out pa-btn--admin"
              :disabled="busy || !packKey"
              @click="$emit('confirm', { boosterKey, packKey, note: (note || '').trim() })"
            >Send recommendation</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** Admin: pick a booster + pack (+ note) to recommend to the client. Emits `confirm` with { boosterKey, packKey, note }. */
export default {
  name: 'PopAuthorityBoosterRecommendModal',
  props: {
    catalogue: { type: Array, required: true },
    /** The current recommendation (camelCase API shape) preselects the booster and pack. */
    current: { type: Object, default: null },
    siteName: { type: String, default: 'your site' },
    busy: { type: Boolean, default: false },
  },
  data () {
    const first = this.catalogue[0] || { key: '', packs: [] }
    const currentBooster = this.current && this.catalogue.find((b) => b.key === this.current.boosterKey)
    const booster = currentBooster || first
    const currentPack = currentBooster && (booster.packs || []).find((p) => p.key === this.current.packKey)
    return {
      boosterKey: booster.key || '',
      packKey: (currentPack && currentPack.key) || ((booster.packs || [])[0] || {}).key || '',
      note: (this.current && this.current.note) || '',
    }
  },
  computed: {
    booster () {
      return this.catalogue.find((b) => b.key === this.boosterKey) || null
    },
    packs () {
      return (this.booster && this.booster.packs) || []
    },
    pack () {
      return this.packs.find((p) => p.key === this.packKey) || null
    },
    boosterName () {
      return (this.booster && this.booster.name) || 'booster'
    },
    packLabel () {
      return (this.pack && this.pack.label) || 'pack'
    },
  },
  watch: {
    boosterKey () {
      if (!this.packs.some((p) => p.key === this.packKey)) {
        this.packKey = (this.packs[0] || {}).key || ''
      }
    },
  },
  methods: {
    money (v) {
      const n = Number(v) || 0
      return n.toLocaleString('en-US', { maximumFractionDigits: 0 })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './setup/setup.scss';

.pa-recommend-modal {
  &__fields {
    margin-top: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 0.85rem;
    font-weight: 700;

    .pa-sel {
      font-weight: 400;
    }
  }

  &__note {
    resize: vertical;
    min-height: 70px;
  }
}
</style>
